export class AppSettings{
    public static DEBUG:boolean = false;
    public static DEBUG_PARAMETERS = {normals:false}
  }